import { flows } from '@repletoryreach/sdk-api';
import { openFileViewer } from '@repletoryreach/sdk-ui/file-viewer';
import { mediaViewerSource } from '@repletoryreach/sdk-media';

/** What opening a document needs: a list row has all of it; a conflict or a coach finding has only the id and name. */
export interface OpenableDocument {
  id: string;
  name: string;
  source_media_id?: string | null;
  source_mime?: string | null;
  source_name?: string | null;
}

/**
 * Open what the AI reads. A document ingested from the library opens its source file (the PDF, the page); a pasted
 * one opens its text. Either way the owner sees the same content the retrieval sees. Throws when the document cannot
 * be read (removed, say), for the caller to say so.
 */
export async function openKbDocument(d: OpenableDocument): Promise<void> {
  if (d.source_media_id) {
    openFileViewer(mediaViewerSource(
      { id: d.source_media_id, url: '', mime_type: d.source_mime ?? 'application/octet-stream', size_bytes: 0, original_name: d.source_name ?? d.name },
      { title: d.name }
    ));
    return;
  }
  const full = (await flows.getKbDocument(d.id)).data;
  // A document known only by its id (a conflict, a coach finding) may still have a source file.
  if (full.source_media_id) return openKbDocument({ ...full, name: d.name || full.name });
  openFileViewer({ kind: 'blob', blob: new Blob([full.body], { type: 'text/plain' }), name: `${d.name || full.name}.txt`, title: d.name || full.name });
}
